import useConnectionRequests from '@/pages/Equipment/hooks/useConnectionRequests.ts'
import useRegularTable from '@/shared/Tables/Table/ctrl/useRegularTable.ts'
import getConnectionRequestsTableFields from '@/pages/Equipment/components/Tables/ConnectionRequestsTable/connectionRequestsTable.fields.tsx'
import Table from '@/shared/Tables/Table'
import { TConnectionRequestProtocol } from '@/pages/Equipment/equipment.types.ts'

interface IProps {
  protocol: TConnectionRequestProtocol
}

const LPConnectionRequestsTable = () => {
  const { connectionRequests: items, loading } = useConnectionRequests('lp-lift')

  const tableCtrl = useRegularTable({
    fields: getConnectionRequestsTableFields('lp-lift'),
    tableKey: 'equipment/connection-requests/lp-lift',
    itemKey: 'id',
    items: items,
  })

  return <Table {...tableCtrl} items={tableCtrl.orderedItems as any} itemKey="id" loading={loading} />
}

const LKDSConnectionRequestsTable = () => {
  const { connectionRequests: items, loading } = useConnectionRequests('lkds')

  const tableCtrl = useRegularTable({
    fields: getConnectionRequestsTableFields('lkds'),
    tableKey: 'equipment/connection-requests/lkds',
    itemKey: 'id',
    items,
  })

  return <Table {...tableCtrl} items={tableCtrl.orderedItems as any} itemKey="id" loading={loading} />
}

const ConnectionRequestsTable = ({ protocol }: IProps) => {
  if (protocol === 'lkds') {
    return <LKDSConnectionRequestsTable />
  }

  return <LPConnectionRequestsTable />
}

export default ConnectionRequestsTable
